import {
  onFormError,
  UserRequestSimpleFin,
  userRequestSimpleFinSchema,
  useUpdateUserSimpleFinApi,
} from '@liquidbudget/common';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  onSuccess?: () => void;
};

export const useUserSimpleFinForm = ({ onSuccess }: Props) => {
  const { mutate, isPending } = useUpdateUserSimpleFinApi({
    onSuccess,
    onError: (errors: any) => onFormError(form, errors),
  });

  const generateDefaultValues = () => ({
    token: '',
  });

  const form = useForm<UserRequestSimpleFin>({
    resolver: zodResolver(userRequestSimpleFinSchema),
    defaultValues: generateDefaultValues(),
  });

  useEffect(() => {
    form.reset(generateDefaultValues());
  }, [form]);

  const handleSubmit = async (values: UserRequestSimpleFin) => {
    mutate(values);
  };

  return {
    form,
    onSubmit: form.handleSubmit(handleSubmit),
    isSubmitting: isPending,
  };
};
